const fmtCents = (c) => (c == null ? "" : `$${(c / 100).toFixed(2)}`);

export const ProposalSectionBlock = ({ section }) => {
  const { type, label, content } = section;
  if (type === "cover") {
    return (
      <div className="rounded-2xl bg-[#0A192F] p-8 text-white" data-testid="proposal-render-cover">
        {content.org_logo_url && <img src={content.org_logo_url} alt={content.org_name} className="mb-4 h-10 object-contain" />}
        <h1 className="text-2xl font-extrabold">{content.org_name}</h1>
        <p className="mt-1 text-sm text-slate-300">Proposal for {content.customer_name}</p>
        {content.service_address && <p className="text-sm text-slate-400">{content.service_address}</p>}
      </div>
    );
  }
  if (type === "quote_pricing") {
    return (
      <div className="rounded-2xl border border-slate-200 p-6" data-testid="proposal-render-pricing">
        <h2 className="mb-3 text-lg font-bold text-slate-900">{label}</h2>
        <div className="space-y-1.5">
          {(content.items || []).map((it, i) => (
            <div key={i} className="flex justify-between text-sm"><span>{it.name} × {it.quantity}</span><span className="font-semibold">{fmtCents(it.line_total_cents)}</span></div>
          ))}
        </div>
        <div className="mt-3 space-y-1 border-t border-slate-200 pt-3 text-sm">
          <div className="flex justify-between"><span className="text-slate-500">Subtotal</span><span>{fmtCents(content.subtotal_cents)}</span></div>
          {content.discount_cents > 0 && <div className="flex justify-between"><span className="text-slate-500">Discount</span><span>-{fmtCents(content.discount_cents)}</span></div>}
          {content.tax_cents > 0 && <div className="flex justify-between"><span className="text-slate-500">Tax</span><span>{fmtCents(content.tax_cents)}</span></div>}
          <div className="flex justify-between text-base font-extrabold"><span>Total</span><span data-testid="proposal-render-total">{fmtCents(content.total_cents)}</span></div>
        </div>
        {content.payment_terms && <p className="mt-3 text-xs text-slate-500">Payment terms: {content.payment_terms}</p>}
        {content.valid_until && <p className="text-xs text-slate-500">Valid until {content.valid_until}</p>}
      </div>
    );
  }
  if (type === "photos" || type === "attachments") {
    if (!content.files?.length) return null;
    return (
      <div className="rounded-2xl border border-slate-200 p-6" data-testid={`proposal-render-${type}`}>
        <h2 className="mb-3 text-lg font-bold text-slate-900">{label}</h2>
        <div className="grid grid-cols-3 gap-2">
          {content.files.map((f) => <img key={f.file_id} src={`${process.env.REACT_APP_BACKEND_URL}${f.url}`} alt="" className="h-28 w-full rounded-lg object-cover" />)}
        </div>
      </div>
    );
  }
  if (type === "customer_acceptance") return null;
  const text = content.text || content.findings || content.description || "";
  if (!text && !content.business_items) return null;
  return (
    <div className="rounded-2xl border border-slate-200 p-6" data-testid={`proposal-render-section-${type}`}>
      <h2 className="mb-2 text-lg font-bold text-slate-900">{label}</h2>
      {content.business_items ? (
        <ul className="list-inside list-disc text-sm text-slate-600">{content.business_items.map((b, i) => <li key={i}>{b.name} × {b.quantity}</li>)}</ul>
      ) : (
        <p className="whitespace-pre-line text-sm text-slate-600">{text}</p>
      )}
    </div>
  );
};
